import { cnTheme } from '@carnica/themes';
import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var NavigationWrapper = function NavigationWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("nav", {
    className: cx('wrapper', cnTheme('light'))
  }, children);
};